module.exports = __webpack_public_path__ + "static/image/history/m/202309@x3.ver2_0_2.png?55e0d936";